import type { IFieldOptions } from '@axo/form/feature/form-input/types';
import type { IOption } from '@axo/shared/ui/input/lib/RadioGroup/RadioGroupUI';
import { generateExpensesOptions } from '../../../../../../utils/generateOptions';

export const insuranceFieldOptions = {
  options: generateExpensesOptions({
    limit: 2_000,
    step: 400,
    suffix: 'kr',
  }),
  registerOptions: {
    valueAsNumber: true,
    required: 'error.required',
  },
  // tooltipValidation: {
  //   message: 'Insurance.tooltip',
  // },
} satisfies IFieldOptions & { options: IOption[] };
